import { getTypeQuestionnaires } from "./getTypeQuestionnaires";

export const getCountOfStepsInAnketa = (isProdamusPayClient?: boolean) => {
  if (getTypeQuestionnaires() === "partner") {
    if (isProdamusPayClient) {
      return 2;
    }
    return 4;
  }

  return 6;
};
